import { captureSentryError } from "~/composables/useSentry.js";

export default defineNuxtRouteMiddleware((to) => {
  const currentKioskCareDay = useCurrentKioskCareDay();

  if (to.path.startsWith("/kiosk")) {
    const careDayId = to.params.id;

    const careDayStore = useCareDayStore();
    const careDay = careDayStore.getCareDayById(careDayId);

    // Should always be set because this middleware runs after the fetch is performed
    if (careDay) {
      currentKioskCareDay.value = careDay;
      return;
    } else {
      // If we ever reach here, we should notify Sentry
      const errorMessage = `CareDay ${careDayId} not found in store after fetching from middleware`;
      captureSentryError(new Error(errorMessage));
    }
  }

  currentKioskCareDay.value = null;
});
